import { useEffect } from 'react';
import { setTrackingData, getTrackingParamsFromStorage } from '../helpers/trackingHelper';

/**
 * Custom hook to capture UTM parameters and Facebook click ID from URL
 * Can be used on any page that needs tracking data capture
 */
export const useTrackingCapture = () => {
  useEffect(() => {
    // Check existing tracking data
    const existingTrackingLocalRaw = getTrackingParamsFromStorage('localStorage');
    const existingTrackingSessionRaw = getTrackingParamsFromStorage('sessionStorage');
    
    // Parse the JSON strings
    const existingTrackingLocal = existingTrackingLocalRaw ? JSON.parse(existingTrackingLocalRaw) : null;
    const existingTrackingSession = existingTrackingSessionRaw ? JSON.parse(existingTrackingSessionRaw) : null;

    const isDefault = (existingTrackingLocal === null && existingTrackingSession === null) || 
                     (existingTrackingLocal?.utm_source === 'direct' || existingTrackingSession?.utm_source === 'direct');

    // Only capture if no existing data or existing data is default
    if (isDefault) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      
      const utmParams = {
        utm_source: urlSearchParams.get('utm_source') || 'direct',
        utm_medium: urlSearchParams.get('utm_medium') || 'none',
        utm_campaign: urlSearchParams.get('utm_campaign') || null,
        utm_content: urlSearchParams.get('utm_content') || null,
        traffic_type: urlSearchParams.get('utm_source') ? 'paid' : 'direct',
        fbc: urlSearchParams.get('fbclid') || urlSearchParams.get('fbc_id') || null,
      };

      setTrackingData(utmParams);
    }
  }, []);
};
